(function registerMerchologyLinkNormalizer() {
  var linkSelector = '[data-normalize-merchology-link][href]';
  var merchologyHosts = new Set([
    'merchology.com',
    'www.merchology.com'
  ]);
  var allowedProtocols = new Set([
    'http:',
    'https:',
    'mailto:',
    'tel:'
  ]);
  var bareHostnamePattern = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}(?::\d{1,5})?(?=\/|[?#]|$)/i;

  function parseUrl(value) {
    try {
      return new URL(value, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function toSafeRootRelativeUrl(url) {
    var pathname = url.pathname;

    if (pathname.indexOf('//') === 0) {
      pathname = '/.' + pathname;
    }

    return pathname + url.search + url.hash;
  }

  function normalizeHref(href) {
    if (typeof href !== 'string') return null;

    var value = href.trim();
    if (!value) return null;

    var hasBareHostname = bareHostnamePattern.test(value);
    var parseValue = value;
    if (hasBareHostname) {
      parseValue = 'https://' + value;
    }

    var url = parseUrl(parseValue);
    if (!url || !allowedProtocols.has(url.protocol)) return null;
    if (!merchologyHosts.has(url.hostname.toLowerCase())) {
      return hasBareHostname ? parseValue : value;
    }

    return toSafeRootRelativeUrl(url);
  }

  function normalizeLink(link) {
    if (!link || link.hasAttribute('data-preserve-host')) return;

    var href = link.getAttribute('href');
    var normalizedHref = normalizeHref(href);

    if (normalizedHref === null) {
      link.removeAttribute('href');
      return;
    }

    if (normalizedHref !== href) {
      link.setAttribute('href', normalizedHref);
    }
  }

  function normalizeLinks(root) {
    if (!root || !root.querySelectorAll) return;

    if (root.matches && root.matches(linkSelector)) {
      normalizeLink(root);
    }

    var links = root.querySelectorAll(linkSelector);

    for (var index = 0; index < links.length; index += 1) {
      normalizeLink(links[index]);
    }
  }

  window.MerchologyLinkNormalizer = {
    normalizeHref: normalizeHref,
    normalizeLink: normalizeLink,
    normalizeLinks: normalizeLinks
  };
})();
